export const objTiers = (state, rootState) => {
	return state.objTiers;
}

export const basePrice = (state, rootState) => {
	return state.basePrice;
}

/*export const userRoles = (state, rootState) => {
	return state.userRoles;
}

export const roleId = (state, rootState) => {
	return state.roleId;
}

export const objRoleEdit = (state, rootState) => {
	return state.objRoleEdit;
}

export const objRolePlists = (state, rootState) => {
	return state.objRolePlists;
}

export const objManuPlists = (state, rootState) => {
	return state.objManuPlists;
}

export const objRolePrivs = (state, rootState) => {	
	return state.objRolePrivs;
}*/
